import { waitTime, sendBack, state } from '@/scripts/boot.js';
import { sequence_loss_sound } from '@/scripts/img_sound_imports.js';
console.log(sequence_loss_sound);
import { startConfetti, stopConfetti } from '@/scripts/helpers/confetti.js';
import { createActionModal } from '@/scripts/UI/actionModal.js';
import * as Blockly from 'blockly';

// 1. Closure variables (Just like latestPath in your share modal!)
let latestMsg = '';
let latestLevelData = {};
let latestErrorMsg = '';
let latestSuccessMsg = '';

const levelCompleteModal = createActionModal(() => {
  const params = new URLSearchParams(window.location.search);
  const shownavParam = params.get('shownav');
  const checkNav = shownavParam !== 'false';
  const showButton = checkNav;

  return {
    heading: latestMsg,
    buttonLabel: 'GO TO NEXT LEVEL',
    showButton,

    onAction: () => {
      // Dynamic routing using the closure data
      if (latestLevelData.currentLevel >= latestLevelData.totalLevels) {
        window.location.href = latestLevelData.nextLevel;
      } else {
        window.location.href = `${window.location.pathname}?level=${+latestLevelData.currentLevel + 1}`;
      }
    },

    onClose: () => {
      // Cleanup using the closure data
      if (typeof createDots === 'function' && latestLevelData.game) {
        createDots(latestLevelData.game, latestLevelData.currentLevel, latestLevelData.totalLevels);
      }
      if (typeof stopConfetti === 'function') stopConfetti();
    },
  };
});
const errorModal = createActionModal(() => ({
  heading: latestErrorMsg,
  buttonLabel: 'Try again',
  variant: 'error',
  onAction: () => {},
  onClose: () => {
    // cleanup, if any
  },
}));
const successModal = createActionModal(() => ({
  heading: latestSuccessMsg,
  buttonLabel: 'Ok',
  variant: 'success',
  onAction: () => {},
  onClose: () => {
    // cleanup, if any
  },
}));
const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
// Level Navigation Helper Functions
const changeLevelPage = () => {
  const level = document.getElementById('level-dropdown').value;

  const url = new URL(window.location.href);
  url.searchParams.set('level', level);

  window.location.href = url.toString();
};

window.changeLevelPage = changeLevelPage;
window.changeLevelPage = changeLevelPage;

const createDots = function (gameNumber, currentLevel, totalLevels) {
  const commonDotContainer = document.querySelector('.dots');
  const params = new URLSearchParams(window.location.search);
  const shownavParam = params.get('shownav'); // e.g. "false" when embedded in iframe
  let checkNav = shownavParam === 'false' ? false : true;

  if (!checkNav) return;
  if (!commonDotContainer) return;
  commonDotContainer.innerHTML = '';
  let levelDropdownString = `<select id="level-dropdown" onchange="changeLevelPage();">`;
  let dotString = '';
  state.levelsArray[gameNumber - 1]?.forEach(function (_, i) {
    if (i == totalLevels) {
      return;
    }
    let curLvlSelected = currentLevel == i + 1 ? 'selected' : '';
    levelDropdownString += `<option ${curLvlSelected} value="${i + 1}">${i + 1}</option>`;
    let curLvl = currentLevel == i + 1 ? 'dots__dot--current' : '';
    dotString += `<button class="dots__dot ${curLvl}" data-slide="${i + 1}">${i + 1}</button>`;
  });
  levelDropdownString += `</select>`;
  commonDotContainer.insertAdjacentHTML('afterend', levelDropdownString);
  commonDotContainer.insertAdjacentHTML('beforeend', dotString);
  const levelDropdown = document.getElementById('level-dropdown');
  const isMobileLayout = window.matchMedia('(max-width: 767px)').matches;
  if (isMobileLayout) {
    commonDotContainer.style.display = 'none';
    levelDropdown.style.display = '';
  } else {
    commonDotContainer.style.display = 'block';
    levelDropdown.style.display = 'none';
  }
};

const resizeDots = () => {
  const commonDotContainer = document.querySelector('.dots');
  const params = new URLSearchParams(window.location.search);
  const shownavParam = params.get('shownav');
  const checkNav = shownavParam !== 'false';

  if (!checkNav) return;
  if (!commonDotContainer) return;
  const levelDropdown = document.getElementById('level-dropdown');
  //TODO: Check if working
  if (!levelDropdown) return;
  if (!commonDotContainer) return;
  const isMobileLayout = window.matchMedia('(max-width: 767px)').matches;
  if (isMobileLayout) {
    commonDotContainer.style.display = 'none';
    levelDropdown.style.display = 'flex';
  } else {
    commonDotContainer.style.display = 'block';
    levelDropdown.style.display = 'none';
  }
};
let levelNames = [
  'dragndrop',
  'sequence',
  'loops',
  'loops2',
  'events',
  'conditionals',
  'nested_loops',
  'functions',
  'variables',
  'data_Simulation',
];
for (var pageIndex = 0; pageIndex < levelNames.length; pageIndex++) {
  let pageName = levelNames[pageIndex];
  if (location.href.includes(pageName)) {
    window.addEventListener('resize', resizeDots);
  }
}
const showWinMsg = async function (
  msg,
  soundEl = new Audio(sequence_loss_sound),
  sendWinFlutter = true,
  levelData = {}
) {
  soundEl.play();
  await sleep(waitTime);

  latestMsg = msg;
  latestLevelData = levelData;

  levelCompleteModal.open();

  // Handle Confetti
  if (typeof startConfetti === 'function') startConfetti();
  const confettiCanvas = document.getElementById('confetti-canvas');
  if (confettiCanvas) confettiCanvas.style.zIndex = 10000;

  await sleep(4000);
  let checkWebview = sessionStorage.getItem('webviewActive');
  if (checkWebview && sendWinFlutter) {
    // Assuming sendBack is available here
    sendBack(JSON.stringify({ type: 'result', body: 'success' }));
  }
};

const addDesignToModal = () => {
  let targetModal = document.querySelectorAll('.box-appearance');
  if (targetModal.length == 0) {
    targetModal = document.querySelectorAll('.card_el');
  }
  targetModal.forEach((modal) => {
    const upperOuterRing = document.createElement('div');
    upperOuterRing.id = 'upper-outer-ring';
    const upperInnerRing = document.createElement('div');
    upperInnerRing.id = 'upper-inner-ring';
    modal.appendChild(upperOuterRing);
    upperOuterRing.appendChild(upperInnerRing);
    const lowerOuterRing = document.createElement('div');
    lowerOuterRing.id = 'lower-outer-ring';
    const lowerInnerRing = document.createElement('div');
    lowerInnerRing.id = 'lower-inner-ring';
    modal.appendChild(lowerOuterRing);
    lowerOuterRing.appendChild(lowerInnerRing);
  });
};
const showErrorMsg = async function (
  msg,
  soundEl = new Audio(sequence_loss_sound),
  sendErrFlutter = true
) {
  latestErrorMsg = msg;

  if (!soundEl) soundEl = new Audio(sequence_loss_sound);
  soundEl.play();

  errorModal.open();
  await sleep(4000);
  let checkWebview = sessionStorage.getItem('webviewActive');
  if (checkWebview && sendErrFlutter) {
    sendBack(JSON.stringify({ type: 'result', body: 'failure' }));
  }
};
const showSuccessMsg = async function (
  msg,
  soundEl = new Audio(sequence_loss_sound),
  sendErrFlutter = true
) {
  latestSuccessMsg = msg;

  if (!soundEl) soundEl = new Audio(sequence_loss_sound);
  soundEl.play();

  successModal.open();
};
function initializeBlocklyLevel(blocklyGame, totalLevels) {
  const params = new URLSearchParams(window.location.search);

  const level = Number(params.get('level')) || 1;

  createDots(blocklyGame, level, totalLevels);

  return level;
}

const DEFAULT_GRID_CONFIG = {
  spacing: 20,
  length: 1,
  colour: '#888',
};
/**
 * Toggles Blockly container scrollbar visibility based on workspace size.
 *
 * @param {Blockly.WorkspaceSvg} workspace
 * @param {HTMLElement} blocklyDiv
 */
function initializeWorkspaceScrollbarVisibility(workspace, blocklyDiv) {
  console.log(workspace, blocklyDiv, 'workspace, blocklyDiv');
  if (!workspace || !blocklyDiv) return;

  const updateScrollbarVisibility = () => {
    const metrics = workspace.getMetrics();

    const needsScrollbars =
      metrics.contentWidth > metrics.viewWidth || metrics.contentHeight > metrics.viewHeight;

    blocklyDiv.classList.toggle('hide-scrollbars', !needsScrollbars);
  };

  // Set initial state.
  updateScrollbarVisibility();

  workspace.addChangeListener((event) => {
    switch (event.type) {
      case Blockly.Events.BLOCK_MOVE:
      case Blockly.Events.BLOCK_CREATE:
      case Blockly.Events.BLOCK_DELETE:
      case Blockly.Events.END_DRAG:
        updateScrollbarVisibility();
        break;
    }
  });
}
export {
  sleep,
  showErrorMsg,
  showWinMsg,
  showSuccessMsg,
  addDesignToModal,
  createDots,
  initializeBlocklyLevel,
  initializeWorkspaceScrollbarVisibility,
  DEFAULT_GRID_CONFIG,
};
